<h1>P52</h1>
<h2>200<small>CE</small></h2>
<ul>
	<li>About the size of a credit card</li>
	<li>The date of the fragment has been updated to closer to 200<small>CE</small> by the John Rylands Library.</li>
	<li>The fragment contains 7 lines from John 18:31-33.</li>
	<li>The first editor dated the fragment to the first half of the second century (between 100<small>CE</small>-150<small>CE</small>). The date was estimated palaeographically, by comparing the handwriting with other manuscripts.<br/>
		<a [appLink]="'https://www.digitalcollections.manchester.ac.uk/view/MS-GREEK-P-00457/1'">Visit the John Rylands Library.</a><br/>
		<img [appBiggen]="{ size: '15dvw', axis: 'width' }" src="P52.webp" style="aspect-ratio: 0.57100766057748968768414849734827/1;" alt="Manuscript fragment P52" title="Manuscript P52 currently housed by the John Rylands Library." /><br/>
	</li>
</ul>
